import React from 'react';
import { ConversationStatus as Status } from '../../../../../store/chat/types';
import styles from './ConversationStatus.module.scss';

interface ConversationStatusProps {
  status: Status;
  className?: string;
}

/**
 * Component that displays the status of a conversation
 * - For new_answer: shows a blue dot
 * - For error: shows a red dot
 * - For answering: shows an animated loading indicator
 * - For inactive: shows nothing
 */
const ConversationStatus: React.FC<ConversationStatusProps> = ({ status, className = '' }) => {
  // Don't render anything for inactive status
  if (status === Status.Inactive) {
    return null;
  }

  // For answering status, show loading indicator
  if (status === Status.Answering) {
    return (
      <span className={`${styles.loadingIndicator} ${className}`}>
        <span className={styles.loadingDot}></span>
        <span className={styles.loadingDot}></span>
        <span className={styles.loadingDot}></span>
      </span>
    );
  }

  // For new_answer or error status, show notification dot
  // with appropriate color
  const isError = status === Status.Error;
  const dotClassName = isError ? styles.errorDot : styles.newAnswerDot;

  return <span className={`${styles.dot} ${dotClassName} ${className}`} />;
};

export default ConversationStatus;